// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { sortBy, groupBy } from 'lodash'
import { createSelector } from 'reselect'

import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').Tag} Tag
 */

/**
 * @type {function(PlottrState): Array<Tag>}
 */
export const allTagsSelector = createSelector(fullFileStateSelector, ({ tags }) => tags ?? [])

/**
 * @param {PlottrState} _state
 * @param {number} id
 */
const selectId = (_state, id) => id
/**
 * @type {function(PlottrState): Array<Tag>}
 */
export const sortedTagsSelector = createSelector(allTagsSelector, (tags) =>
  sortBy(tags, ['title', 'id'])
)

/**
 * @type {function(PlottrState, number): (Tag | Null)}
 */
export const singleTagSelector = createSelector(
  allTagsSelector,
  selectId,
  (tags, propId) => tags.find((tag) => tag.id == propId) ?? null
)

/**
 * @type {function(PlottrState): Record<String, Array<Tag>>}
 */
export const tagsByCategorySelector = createSelector(allTagsSelector, (tags) => {
  const grouped = groupBy(tags, 'categoryId')
  if (grouped['undefined'] !== undefined) {
    grouped['null'] = grouped['undefined'].concat(grouped['null'] || [])
    delete grouped['undefined']
  }
  return grouped
})

/**
 * @type {function(PlottrState): Record<number, String>}
 */
export const stringifiedTagsByIdSelector = createSelector(allTagsSelector, (tags) => {
  return tags.reduce((acc, nextTag) => {
    return {
      ...acc,
      [nextTag.id]: JSON.stringify(nextTag).toLowerCase(),
    }
  }, {})
})
